import { Button } from '@shared/components';
import './StoryView.css';

/**
 * View (UI) for Story/Genesis Section
 * Pure presentational component - receives all data and handlers as props
 */
export const StoryView = ({ story, onFollowProject }) => {
  return (
    <section className="story">
      <div className="container">
        <div className="story__content">
          <h2 className="story__title">{story.title}</h2>
          
          <div className="story__paragraphs">
            {story.paragraphs.map((paragraph, index) => (
              <p key={index} className="story__paragraph">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoryView;
